import LipSyncState from '@/store/LipSync';
import { EXPORT_CURRENT_FPS, EXPORT_QUALITY, EXPORT_RESOLUTION } from '@/utils/const';
import request from '@/utils/request';

import { ApiResult } from '.';

interface personalType {
  type: string | number;
  pageNum: number;
  pageSize: number;
}
/**
 * 数字人列表数据
 * @param data
 * @returns
 */
export const fetchPersonalList = async (data: personalType): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dhc/template/personal/list', {
    method: 'POST',
    data,
  });
  return res;
};

interface TTSDataType {
  templateId: string;
  templateType?: number;
}

export interface TTSPreviewType {
  text?: string;
  type?: number;
  srtUrl?: string;
  // 是否需要文本停顿，默认true
  needSsmlTrans: boolean;
  // 是否需要短剧，默认false
  needBreak?: boolean;
  data: TTSDataType;
}
/**
 * 生成tts预览
 * @param data
 * @returns
 */
export const fetchTTSPreview = async (data: TTSPreviewType): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dhc/task/simple/ttsPreview', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 查询生成tts状态
 * @param data
 * @returns
 */
export const fetchTTSQueryResult = async (data: {
  businessId: string;
}): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/cloud/make/queryResult', {
    method: 'POST',
    data,
  });
  return res;
};

export interface avatarTrainType {
  videoUrl?: string;
  title?: string;
  previewUrl?: string;
  gender?: number;
  voiceClone?: boolean;
  voiceUrl?: string;
  voiceCloneType?: number; // 5
  voicePreviewText?: string; // 随机取一个
}

/**
 * 创建数字人
 * @param data
 * @returns
 */
export const fetchAvatarTrain = async (
  data: avatarTrainType,
): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/cloud/avatar/train', {
    method: 'POST',
    data,
  });
  return res;
};

export interface IClipItem {
  clipId: string; // 数字人所在comp 的 uuid
  clipTemplateCode?: string; //当前clip使用的素材code
  ttsUrl?: string; //
  textDriver?: boolean;
  text?: string;
  voiceModelId?: string;
  modelSourceType?: string | number;
}
/**
 * 视频导出传参数
 */
interface IExportData {
  projectId: number;
  title?: string;
  version?: number;
  projectWidth: number;
  projectHeight: number;
  resolution?: number;
  fps?: number;
  quality?: number;
  projectDuration?: number;
  clips?: Array<IClipItem>; //仅需要数字人的clip
}

/**
 * 视频导出
 * @param data
 * @returns
 */
// let { playerSize } = LipSyncState.getState();
export const projectExport = async (data: IExportData): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/project/export/lip/submit', {
    method: 'POST',
    data: {
      fps: EXPORT_CURRENT_FPS,
      quality: EXPORT_QUALITY,
      ...data,
      // resolution: EXPORT_RESOLUTION,
      // resolution:
      //   playerSize.width > playerSize.height ? playerSize.height : playerSize.width,
    },
  });
  return res;
};
